// import './App.css';
import { useEffect, useState } from "react";
import {
  FormControl,
  TextField,
  Button,
  Switch,
  FormControlLabel,
  Select,
  InputLabel,
  MenuItem,
  Grid,
  Container,
} from "@material-ui/core";
import LoadingOverlay from "react-loading-overlay";
import TargetSelector from "./targetSelector";
import { updateQuestion, createQuestion } from "../services/api";
import ReportSelector from "./reportSelector";
import ReactFlagsSelect from 'react-flags-select';

const classes = {};

function QuestionForm({ question, assessmentSectionId, onSaveSuccess, ...props }) {
  const [languagePartForm, setLanguagePartForm] = useState({ EN: { text: "", placeholder: "", validation_text: "" } });
  const [language, setLanguage] = useState("EN");
  const [languageForSelect, setLanguageForSelect] = useState("GB");

  const [target, setTarget] = useState("");
  const [isFirst, setIsFirst] = useState(false);
  const [type, setType] = useState("");
  const [inputType, setInputType] = useState("");
  const [regex, setRegex] = useState("");
  const [loading, setLoading] = useState(false);
  const [report, setReport] = useState(null);

  useEffect(() => {
    if (question.questionTRs?.length) {
      let obj = {};
      question.questionTRs.forEach((tr) => {
        obj[tr.language] = {
          text: tr.text || "",
          placeholder: tr.placeholder || "",
          validation_text: tr.validation_text || "",
          id: tr.id || undefined
        };
      });
      if (!obj["EN"]) {
        setLanguage(obj[question.questionTRs[0].language]);
      }
      setLanguagePartForm(obj);
    }
  }, [question]);

  const refreshForm = () => {
    if (question.id) {
      setTarget(question.target);
      setIsFirst(question.is_first);
      setType(question.type);
      setInputType(question.input_type);
      setRegex(question.regex);
      setReport(question.report_category);
    } else {
      setTarget("");
      setType("");
      setIsFirst(false);
      setInputType("");
      setRegex("");
    }
  };

  const saveChanges = () => {
    question.type = type;
    question.target = target;
    question.is_first = isFirst;
    question.input_type = inputType;
    question.regex = regex;
    question.report_category = report || 1;
    

    setLoading(true);
    question.questionTRs = [];
    Object.keys(languagePartForm).forEach((key) => {
      question.questionTRs.push({
        language: key,
        text: languagePartForm[key].text,
        placeholder: languagePartForm[key].placeholder,
        validation_text: languagePartForm[key].validation_text,
        id: languagePartForm[key].id || undefined
      });
    });
    if (question.id) {
      //store it somewhere in a shared state?
      //how about an object that has language as the key, and the text, placeholder and validation_text as values
      //do i need to keep that object in the state?
      updateQuestion(question)
        .then((res) => {
          onSaveSuccess(res);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      question.assessment_section_id = assessmentSectionId;
      createQuestion(question)
        .then((res) => {
          onSaveSuccess(res);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    refreshForm();
  }, []);

  const handleFieldChange = (f) => {
    return (event) => {
      f(event.target.value);
    };
  };

  const onChangeText = (value) => {
    setLanguagePartForm((oldForm) => {
      let form = { ...oldForm };
      form[language].text = value;
      return form;
    });
  };

  const onChangePlaceholder = (value) => {
    setLanguagePartForm((oldForm) => {
      let form = { ...oldForm };
      form[language].placeholder = value;
      return form;
    });
  };

  const onChangeValidationText = (value) => {
    setLanguagePartForm((oldForm) => {
      let form = { ...oldForm };
      form[language].validation_text = value;
      return form;
    });
  };

  const onChangeLanguage = (value) => {
    /* TO CHANGE FROM GB TO EN (country to language) */
    let newValue;
    if (value === "GB") {
      newValue = "EN";
    } else {
      newValue = value;
    }

    setLanguage(newValue);
    setLanguageForSelect(value);
    if (!languagePartForm[newValue]) {
      setLanguagePartForm((oldForm) => {
        let form = { ...oldForm };
        form[newValue] = {
          text: "",
          placeholder: "",
          validation_text: "",
        };
        return form;
      });
    }
  };

  return (
    <LoadingOverlay active={loading} spinner>
      <div class="bodyModal">
        <FormControl className="inputForms flagSelect">
          <InputLabel id="languageLabelAssessmentSection">Language</InputLabel>
          {/* <Select
              labelId="languageLabelAssessmentSection"
              id="languageAssessmentSection"
              value={language}
              onChange={handleFieldChange(onChangeLanguage)}
            >
              <MenuItem value={"EN"}>English</MenuItem>
              <MenuItem value={"ES"}>Spanish</MenuItem>
            </Select> */}
          <ReactFlagsSelect
            labelId="languageLabelAssessmentSection"
            id="languageAssessmentSection"
            selected={languageForSelect}
            onSelect={(code) => onChangeLanguage(code)}
            countries={["ES", "GB"]}
            customLabels={{ GB: "English", ES: "Spanish" }}
            searchable
          />
        </FormControl>

        <FormControl>
          <TextField
            label="Text"
            value={languagePartForm[language].text}
            onChange={handleFieldChange(onChangeText)}
            className="inputForms"
          />
          {/* <TextField
                        label="target"
                        value={target}
                        onChange={handleFieldChange(setTarget)}
                        className={classes.formTextField}
                    /> */}

          <TargetSelector {...props} value={target} setValue={setTarget} className="inputForms" />
          <ReportSelector value={report} setValue={setReport}/>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <FormControl className="inputForms">
                <InputLabel id="targetLabelAssessmentSection">Type</InputLabel>
                <Select
                  labelId="targetLabelAssessmentSection"
                  id="targetAssessmentSection"
                  value={type}
                  onChange={handleFieldChange(setType)}
                >
                  <MenuItem value={"multi-choice"}>Select</MenuItem>
                  <MenuItem value={"text-field"}>Text Field</MenuItem>
                  <MenuItem value={"perc-picker"}>Percentage Picker</MenuItem>
                  <MenuItem value={"dob-picker"}>Date Picker</MenuItem>
                  <MenuItem value={"multi-choice-multi-select"}>Multiple Select</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl className="inputForms">
                <InputLabel id="inputTypeLabelAssessmentSection">Input Type</InputLabel>
                <Select
                  labelId="inputTypeLabelAssessmentSection"
                  id="inputTypeAssessmentSection"
                  value={inputType}
                  label="Assessment Section"
                  onChange={handleFieldChange(setInputType)}
                >
                  <MenuItem value={"number"}>Number</MenuItem>
                  <MenuItem value={"text"}>Text</MenuItem>
                  <MenuItem value={"Email"}>Email</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                label="Placeholder"
                value={languagePartForm[language].placeholder}
                onChange={handleFieldChange(onChangePlaceholder)}
                className="inputForms"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              {" "}
              <TextField label="Regex" value={regex} onChange={handleFieldChange(setRegex)} className="inputForms" />
            </Grid>
          </Grid>

          <TextField
            label="Validation Message"
            value={languagePartForm[language].validation_text}
            onChange={handleFieldChange(onChangeValidationText)}
            className="inputForms"
          />
          <FormControlLabel
            control={
              <Switch
                checked={isFirst}
                onChange={(evt) => {
                  setIsFirst(evt.target.checked);
                }}
                inputProps={{ "aria-label": "controlled" }}
              />
            }
            label="Is First"
          />
        </FormControl>

        <div className="text-center">
          <Button variant="contained" color="primary" onClick={saveChanges} className="btn-main-limber mb-15 mt-15">
            Save
          </Button>
        </div>
      </div>
    </LoadingOverlay>
  );
}

export default QuestionForm;
